module.exports = __webpack_public_path__ + "static/media/scheduleBg.02e36482.jpg";